import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr'
import { Russian } from 'flatpickr/dist/l10n/ru'
import { Spanish } from 'flatpickr/dist/l10n/es'
import { Chinese } from 'flatpickr/dist/l10n/zh'
import 'flatpickr/dist/themes/airbnb.css'

const locales = {
  fr: French,
  ru: Russian,
  es: Spanish,
  'zh-hans': Chinese,
}

const dateIsPast = selectedDate => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return selectedDate < today
}

const flatpickrConfig = {
  // this allows editing but also enables HTML5 validation
  allowInput: true,

  dateFormat: 'd-m-Y',

  disableMobile: false,

  disable: [dateIsPast],
  defaultDate: 'today',

  altInput: true,
  altFormat: 'd M Y',
}

// on desktop we use flatpickr
export const desktopDatepicker = ({ input, toggleFocus }) => {
  let fp
  const config = { ...flatpickrConfig }
  const lang = document.documentElement.getAttribute('lang')
  if (locales[lang]) {
    config.locale = locales[lang]
  }
  config.onOpen = toggleFocus.bind(null, true)
  config.onClose = toggleFocus.bind(null, false)

  // trigger re-validation
  config.onChange = () => {
    if (fp.altInput) {
      fp.altInput.dispatchEvent(new Event('input'))
    }
  }

  fp = flatpickr(input, config)

  if (fp.altInput) {
    const events = ['keydown', 'cut', 'paste']
    events.forEach(evtType => (fp.altInput[`on${evtType}`] = () => false))
  }
}

// on Android/IOS, we use native datepickers
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const pad = n => (n < 10 ? `0${n}` : n)

export const mobileDatepicker = input => {
  const datePicker = document.createElement('input')
  datePicker.type = 'date'
  datePicker.style.opacity = '0'
  datePicker.style.position = 'absolute'
  datePicker.style.top = '0'
  datePicker.style.left = '0'
  datePicker.style.width = '100%'
  datePicker.style.height = '100%'
  datePicker.style.fontSize = '16px' // prevent ios zoom
  input.parentElement.insertBefore(datePicker, input)
  input.parentElement.style.position = 'relative'
  input.type = 'text'
  input.addEventListener('focus', e => {
    e.preventDefault() // prevent writing text in ios
    input.blur() // prevent writing text in android
    datePicker.click() // only click works in android, not focus though
  })

  const syncValue = () => {
    let [y, m, d] = datePicker.value.split('-')
    if (datePicker.value === '') {
      y = new Date().getFullYear()
      m = new Date().getMonth() + 1
      d = pad(new Date().getDate())
    }
    input.value = `${d} ${months[m - 1]} ${y}`
  }
  datePicker.addEventListener('change', syncValue)
  syncValue()
}
